<template>
  <div class="home">
    <greeting :year="year" :daySaturday="daySaturday" :daySunday="daySunday" :weinprobenCounter="weinprobenCounter"></greeting>
    <introduction :year="year" :daySaturday="daySaturday" :daySunday="daySunday" :weinprobenCounter="weinprobenCounter" :isFullSite="isFullSite"></introduction>
    <!-- <booth></booth> -->
  </div>
</template>

<script>
// @ is an alias to /src
import Greeting from '@/components/Greeting.vue';
import Introduction from '@/components/Introduction.vue';

export default {
  name: 'home',
  components: {
    Greeting,
    Introduction
  },
  data() {
    return {
      year: "2024",
      daySaturday: "17",
      daySunday: "18",
      weinprobenCounter: "51",
      isFullSite: false // show booth data, set to false for preview
    }
  }
}
</script>

<style scoped>
    .home {
        width: 100%;
        /* height: 100%; */
    }
</style>
